import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';

const Home = () => {
    return (
        <>
            <Hero />
            <About />
            <Services />
        </>
    );
};

export default Home;